// @ts-nocheck
import { Plugin } from 'E:/zhipu/知因-aminer/zhiyin-v2/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request','qiankun',],
});

export { plugin };
